import { createAction, props } from '@ngrx/store';

import { CountyGetResponse } from '../../typings/county';
import { SystemConfigurationsMobileSettingsResponse } from '../../typings/system-configurations';

export const loadSettings = createAction(
  '[Setting] Load Settings',
  props<{ payload: { isOnboardFlow?: boolean; referralCode: string } }>()
);

export const loadSettingsSuccess = createAction(
  '[Setting] Load Settings Success',
  props<{
    payload: {
      data: SystemConfigurationsMobileSettingsResponse;
      isOnboardFlow?: boolean;
    };
  }>()
);

export const loadSettingsFailure = createAction(
  '[Setting] Load Settings Failure',
  props<{ payload: { error: Error } }>()
);

export const loadSettingsReset = createAction('[Setting] Load Settings Reset');

export const updateApplicationIcon = createAction(
  '[Setting] Update Application Icon',
  props<{ payload: { useDefault: boolean } }>()
);

export const updateApplicationIconSuccess = createAction(
  '[Setting] Update Application Icon Success',
  props<{ payload: { alternateAppIconUsed: boolean } }>()
);

export const updateApplicationIconFailure = createAction(
  '[Setting] Update Application Icon Failure',
  props<{ payload: { error: Error } }>()
);

export const updateReferralCode = createAction(
  '[Setting] Update Referral Code',
  props<{ payload: { code: string; password: string | null; username: string | null } }>()
);

export const updateReferralCodeSuccess = createAction(
  '[Setting] Update Referral Code Success',
  props<{
    payload: { code: string; data: SystemConfigurationsMobileSettingsResponse };
  }>()
);

export const updateReferralCodeFailure = createAction(
  '[Setting] Update Referral Code Failure',
  props<{ payload: { error: Error } }>()
);

export const refreshReferralCode = createAction('[Setting] Refresh Referral Code');

export const refreshReferralCodeSuccess = createAction(
  '[Setting] Refresh Referral Code Success',
  props<{
    payload: {
      data: SystemConfigurationsMobileSettingsResponse;
    };
  }>()
);

export const refreshReferralCodeFailure = createAction(
  '[Setting] Refresh Referral Code Failure',
  props<{ payload: { error: Error } }>()
);

export const updateSelectedState = createAction(
  '[Setting] Update Selected State',
  props<{ payload: { state: string | null } }>()
);

export const updateAvailableCountiesSuccess = createAction(
  '[Setting] Update Available Counties Success',
  props<{
    payload: CountyGetResponse;
  }>()
);

export const updateAvailableCountiesFailure = createAction(
  '[Setting] Update Available Counties  Failure',
  props<{ payload: { error: Error } }>()
);

export const updateSelectedCounty = createAction(
  '[Setting] Update Selected County',
  props<{ payload: { county: string | null } }>()
);

export const toggleDebugMode = createAction('[Setting] Toggle Debug Mode');

export const toggleEnableTooltips = createAction('[Setting] Toggle Enable Tooltips');

export const resetApplication = createAction('[Setting] Reset Application');
